import { useEffect } from 'react';

interface CanonicalTagProps {
  url: string;
}

/**
 * Component that adds a canonical link tag to the document head
 * to prevent duplicate content issues in search engines.
 * 
 * @param url - The canonical URL for the current page (should be absolute URL)
 */
export function CanonicalTag({ url }: CanonicalTagProps) {
  useEffect(() => {
    // Remove any existing canonical tags to avoid conflicts
    const existingCanonical = document.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.setAttribute('href', url);
    } else {
      // Create canonical link element if it doesn't exist
      const canonicalLink = document.createElement('link');
      canonicalLink.rel = 'canonical';
      canonicalLink.href = url;
      document.head.appendChild(canonicalLink);
    }
  }, [url]);
  
  return null; // This component doesn't render anything
}
